import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';

export const useRealtimeQuotations = (workOrderId = null) => {
  const [quotations, setQuotations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isLive, setIsLive] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(null);

  const toCamelCase = (obj) => {
    if (!obj || typeof obj !== 'object') return obj;
    if (Array.isArray(obj)) return obj?.map(toCamelCase);

    return Object.keys(obj)?.reduce((acc, key) => {
      const camelKey = key?.replace(/_([a-z])/g, (_, letter) => letter?.toUpperCase());
      acc[camelKey] = toCamelCase(obj?.[key]);
      return acc;
    }, {});
  };

  const fetchQuotations = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      let query = supabase
        ?.from('quotation_items')
        ?.select(`
          *,
          work_order:work_orders(
            id,
            folio_ot,
            estado_ot
          ),
          inspection:technical_inspections(
            id,
            category,
            status
          )
        `)
        ?.order('created_at', { ascending: false });

      if (workOrderId) {
        query = query?.eq('work_order_id', workOrderId);
      }

      const { data, error: fetchError } = await query;

      if (fetchError) throw fetchError;

      setQuotations(toCamelCase(data || []));
      setLastUpdate(new Date());
    } catch (err) {
      console.error('Error fetching quotations:', err);
      setError(err?.message || 'Error al cargar cotizaciones');
    } finally {
      setLoading(false);
    }
  }, [workOrderId]);

  useEffect(() => {
    fetchQuotations();

    const channel = supabase
      ?.channel('quotations_changes')
      ?.on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'quotation_items'
        },
        (payload) => {
          console.log('Quotation change detected:', payload);
          setIsLive(true);
          fetchQuotations();
          
          setTimeout(() => setIsLive(false), 2000);
        }
      )
      ?.subscribe();

    return () => {
      supabase?.removeChannel(channel);
    };
  }, [fetchQuotations]);

  return {
    quotations,
    loading,
    error,
    isLive,
    lastUpdate,
    refetch: fetchQuotations
  };
};